"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLUMN_EDITORS = {
    CHECKBOX: "Checkbox",
    DROP_DOWN: "DropDown",
    TEXT_FIELD: "TextField",
    BUTTON: "Button",
    AD_FORMAT: "AdFormat",
    TARGETING: "Targeting",
    SPECIAL_PRICE: "SpecialPrice",
    PERIOD: "Period"
};
exports.DATA_TYPES = {
    BOOLEAN: "boolean",
    CURRENCY: "currency",
    NUMBER: "number",
    TEXT: "text",
    LINK: "link",
    LIST: "list",
    IMAGE: "image"
};
exports.VERTICAL_ALIGNMENTS = {
    TOP: "top",
    CENTER: "center",
    BOTTOM: "bottom"
};
exports.HORIZONTAL_ALIGNMENTS = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};
//# sourceMappingURL=planeditor.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/planeditor.js
// module id = 6
// module chunks = 0